import React from 'react';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://dentalimplant-en.impultienda.ar/checkout/';
type CtaButtonProps = {
  label: string;
  id?: string;
  note?: string;
  tone?: 'dark' | 'light';
};
export function CtaButton({
  label,
  id,
  note,
  tone = 'light'
}: CtaButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-385" data-mp="20sr1nk3sv0gs">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center font-display text-[17px] font-extrabold uppercase leading-snug text-white shadow-[0_6px_0_0_#0A7A3F] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-1 active:shadow-[0_2px_0_0_#0A7A3F] focus:outline-none focus-visible:ring-4 focus-visible:ring-accent/60 sm:px-8 sm:text-xl" data-id="element-386" data-mp="1m4w6lx2bkk0j">
        <span data-id="element-387" data-mp="184lgiw8u39gf">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-388" data-mp="184v64ipyvell" />
      </a>
      {note && <p className={`mt-4 flex items-center justify-center gap-1.5 text-center text-sm font-medium ${tone === 'dark' ? 'text-white/75' : 'text-muted'}`} data-id="element-389" data-mp="2cgou82mop251">
          <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-390" data-mp="2ljhh7tou2rp2" />
          {note}
        </p>}
    </div>;
}